// W40.2 (2026-10-21): the approved "Up next" card (`section.next`, aria-label
// "Next customer preview") on every customer task screen whose approved file
// carries it. MEASURED in the reference manifests (`regions.next`): present on
// 01, 03, 04, 05-10, 14-17, 19, 21, 22 and both companions; absent on 02, 11,
// 12, 13, 18, 20. 14 and 15 draw their own "Return to <name>'s current action"
// card; 01 wires the queue itself beside Finish & Next; this component covers
// the rest with the SAME data the 01 card uses (W27 lookahead read via
// useRepQueue, lookahead only) and the same honest states.
//
//   <UpNext customerId />       preview / dev-mock: the design fixture card
//                               (NextCustomer, MICHAEL) exactly as before;
//                               real session: the queue-hydrated card.
//   <QueueUpNext customerId />  real session only (null in preview); for the
//                               W2A-lower screens that keep their own fixture
//                               markup in preview.
import type { ReactNode } from 'react';
import { MICHAEL } from '../../data/mockData.js';
import { NextCustomer, QueueNextCustomer } from './NextCustomer.js';
import { useRepQueue } from './useRepQueue.js';

export interface UpNextProps {
  customerId: string;
}

export function QueueUpNext({ customerId }: UpNextProps): ReactNode {
  const queue = useRepQueue(customerId, 3, { lookaheadOnly: true });
  return (
    <QueueNextCustomer
      status={queue.lookaheadStatus}
      items={queue.lookahead}
      degraded={queue.lookaheadDegraded}
    />
  );
}

export function UpNext({ customerId }: UpNextProps): ReactNode {
  return (
    <>
      <NextCustomer
        customer={MICHAEL}
        summary="Help plan his next subscription order"
        trigger="Customer emailed"
        age="8 minutes ago"
      />
      <QueueUpNext customerId={customerId} />
    </>
  );
}
